import Icon from '../Icon'
import { FieldQtyButton, FieldQtyInput, FieldQtyWrapper } from './FieldQty.styles'

interface FieldQtyProps {
  value: number
  onChange: (value: number) => void
  disablePlus?: boolean
  disableMinus?: boolean
}

const FieldQty = ({ value, onChange, disablePlus = false, disableMinus = false }: FieldQtyProps) => {
  const add = () => {
    if (disablePlus) {
      return
    }

    onChange(value + 1)
  }

  const remove = () => {
    if (disableMinus) {
      return
    }

    onChange(value - 1)
  }

  return (
    <FieldQtyWrapper>
      <FieldQtyButton type="button" onClick={remove} disabled={disableMinus}>
        <Icon name="minus" />
      </FieldQtyButton>
      <FieldQtyInput readOnly value={value} />
      <FieldQtyButton type="button" onClick={add} disabled={disablePlus}>
        <Icon name="plus" />
      </FieldQtyButton>
    </FieldQtyWrapper>
  )
}

FieldQty.propTypes = {}

export default FieldQty
